import { useEffect, useRef } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { toast } from 'sonner';
import { useAuth } from '@/contexts/AuthContext';
import { reportsApi } from '@/lib/api';

export const AuthCallback = () => {
  const { googleLogin } = useAuth();
  const location = useLocation();
  const nav = useNavigate();
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const sessionId = new URLSearchParams(location.hash.slice(1)).get('session_id');
    (async () => {
      try {
        await googleLogin(sessionId);
        const raw = sessionStorage.getItem('wellth_latest_report');
        let goResults = false;
        if (raw) {
          try {
            const parsed = JSON.parse(raw);
            if (parsed && !parsed.user_id) {
              await reportsApi.attach({ intake: parsed.intake, report: parsed.report });
              goResults = true;
            }
          } catch { /* ignore */ }
        }
        toast.success('Signed in with Google');
        nav(goResults ? '/results' : location.pathname, { replace: true });
      } catch (e) {
        toast.error(e.response?.data?.detail || 'Google sign-in failed');
        nav('/login', { replace: true });
      }
    })();
  }, [googleLogin, location, nav]);

  return <div className="min-h-[60vh]" data-testid="auth-callback" />;
};
